import { getAllStaff } from "../utils/newDbUtils";

export const staffModule = {
  state: () => ({
    staffList: [],
  }),
  mutations: {
    SET_STAFF(state, data) {
      state.staffList = data;
    },
  },
  actions: {
    aGetAllStaff({ commit }, data) {
      commit("SET_STAFF", data);
    },
  },
  getters: {
    gStaffList(state) {
      return state.staffList;
    },
  },
};